module.exports = __webpack_public_path__ + "themes/mf/img/multiplier-x10.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/multiplier-x10.png
// module id = 79
// module chunks = 3